import React from 'react'
import { useIntl } from 'react-intl'
import Dialog, { type DialogProps } from './Dialog'
import UploadMediaForm from '../MediaLibrary/UploadMediaForm'

export type ModalUploadMediaProps = {
	onSubmit: (files: File[]) => void
	onCancel?: () => void
} & Omit<DialogProps, 'onSubmit'>
const ModalUploadMedia = ({
	onSubmit,
	onCancel = undefined,
	...rest
}: ModalUploadMediaProps) => {
	const { formatMessage } = useIntl()
	return (
		<Dialog
			title={formatMessage({
				id: 'upload_media.modal.heading',
			})}
			onClose={onCancel}
			fullWidth
			maxWidth="sm"
			{...rest}
		>
			<UploadMediaForm onSubmit={onSubmit} onCancel={onCancel} />
		</Dialog>
	)
}

export default ModalUploadMedia
